import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionAuthentication from "./component";
import { withRouter } from "react-router-dom";
import { updateProfile, saveUserConsent, getBifrostProfileDetails } from "../../configuration/actions";
import { fetchInspectionDetailsViaLeadToken, fetchInspectionDetails, fetchLoginDetailsViaLeadToken, fetchLoginDetails } from "../post-inspection-diy/actions";
import { checkLeadPhoneNumber, sendOtpViaLeadToken, verifyOtpViaLeadToken } from "../../mobile/reg-number-details-wrapper/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse
    },
    user: { mobile, secureToken, isLoggedIn },
    repeatUserTransition: {
        pageLoading,
        loaderTitle
    }
}) => ({
    secureToken,
    inspectionResponse,
    mobile,
    pageLoading,
    loaderTitle,
    isLoggedIn
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateProfileConnect: updateProfile,
    saveUserConsentConnect: saveUserConsent,
    fetchInspectionDetailsViaLeadTokenConnect: fetchInspectionDetailsViaLeadToken,
    fetchInspectionDetailsConnect: fetchInspectionDetails,
    sendOtpViaLeadTokenConnect: sendOtpViaLeadToken,
    verifyOtpViaLeadTokenConnect: verifyOtpViaLeadToken,
    checkLeadPhoneNumberConnect: checkLeadPhoneNumber,
    fetchLoginDetailsViaLeadTokenConnect: fetchLoginDetailsViaLeadToken,
    fetchLoginDetailsConnect: fetchLoginDetails,
    getBifrostProfileDetailsConnect: getBifrostProfileDetails
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionAuthentication));
